import { mix, observable, passthruLayout, watch } from "@chorda/core";
import "bulma-checkradio/dist/css/bulma-checkradio.min.css";
export const Radio = (props) => {
    return mix({
        layout: passthruLayout,
        templates: {
            input: {
                tag: 'input',
                css: 'is-checkradio',
                dom: {
                    type: 'radio'
                },
                reactions: {
                    //                     value: v => ({dom: {
                    //                         value: v && 'checked', 
                    // //                        defaultChecked: v && 'checked'
                    //                     }}),
                    name: v => ({ dom: { id: v } }),
                },
                joints: {
                    setValue: ({ value, $dom }) => {
                        watch(() => {
                            if ($dom.$value) {
                                $dom.$value.checked = value.$value;
                            }
                        }, [value, $dom]);
                    }
                }
            },
            label: {
                tag: 'label',
                reactions: {
                    name: v => ({ dom: { htmlFor: v } })
                }
            }
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        templates: {
            label: {
                text: props.label
            },
            input: {
                events: {
                    $dom: {
                        change: props.onChange && ((e, scope) => {
                            props.onChange(true, scope);
                        })
                    }
                }
            }
        },
        defaults: {
            value: () => observable(props.value),
            name: () => props.name,
        },
        injections: {
            value: props.value$
        }
    });
};
